//组件信息
let componentInfos = {
	'system_user_list': resolve => require(['../pages/system/user/list'], resolve),
	'system_user_edit': resolve => require(['../pages/system/user/edit'], resolve),
	'system_role_list': resolve => require(['../pages/system/role/list'], resolve),
	'system_role_auth': resolve => require(['../pages/system/role/roleauth'], resolve),
	'boxmai_qc_qc_list': resolve => require(['../pages/fa/qc/list'], resolve),
	'boxmai_qc_qc_edit': resolve => require(['../pages/fa/qc/edit'], resolve),
	'boxmai_qc_qc_img': resolve => require(['../pages/fa/qc/img'], resolve),
	// 'boxmai_boxmai_boxmai_list': resolve => require(['../pages/boxmai/boxmai/boxmai/list'], resolve),
	// 'boxmai_boxmai_boxmai_edit': resolve => require(['../pages/boxmai/boxmai/boxmai/edit'], resolve),
	// 'boxmai_boxmai_brand_list': resolve => require(['../pages/boxmai/boxmai/brand/list'], resolve),
	// 'boxmai_boxmai_boxmai_import_pa': resolve => require(['../pages/boxmai/boxmai/boxmai/import-pa'], resolve),
	'boxmai_boxmai_brandconfig_list': resolve => require(['../pages/boxmai/boxmai/brand/brandconfig'], resolve),
	'boxmai_boxmai_brandprepack': resolve => require(['../pages/boxmai/boxmai/brand/brandprepack'], resolve),
	// 'FA_boxmai_boxmai_list': resolve => require(['../pages/fa/boxmai/list'], resolve),
	// 'FA_boxmai_boxmai_import': resolve => require(['../pages/fa/boxmai/import'], resolve),
	'aero_boxmai_list': resolve => require(['../pages/aero/boxmai/list'], resolve),
	'aero_boxmai_import': resolve => require(['../pages/aero/boxmai/import'], resolve),
	'aero_schedule_list': resolve => require(['../pages/aero/schedule/list'], resolve),
	'aero_indcdate_list': resolve => require(['../pages/aero/indcdate/list'], resolve),
	'aero_indcdate_edit': resolve => require(['../pages/aero/indcdate/edit'], resolve),
	'aero_country_list': resolve => require(['../pages/aero/country/list'], resolve),
	'aero_country_edit': resolve => require(['../pages/aero/country/edit'], resolve),
	'aero_report_customer_list': resolve => require(['../pages/aero/report/customer/list'], resolve),
	'fa_style_fact_list': resolve => require(['../pages/fa/stylefact/list'], resolve),
	'fa_style_fact_edit': resolve => require(['../pages/fa/stylefact/edit'], resolve),
	'macy_materialdb_list': resolve => require(['../pages/macys/db/materialDb/list'], resolve),
	'macy_submaterialdb_list': resolve => require(['../pages/macys/db/subMaterialDb/list'], resolve),
};

export default {
	tabComponent: componentInfos
}



// WEBPACK FOOTER //
// ./src/config/tabroutes.js